
import { createAction } from 'redux-starter-kit';
import { requestStart, requestFailed, requestSucceded } from '../../domain/requests/RequestActions';
import { get, post } from '../../../utility/via-fetch';
import { putInspection } from '../../domain/inspection/inspectionActions';
import { addMessage } from '../application/messageUiActions';


/**
 * An action creator that represents an inspection being requested.
 * @example dispatch(fetchInspection(requestId)
 */
export const fetchInspection = createAction('FETCH_INSPECTION');


/**
 * A thunk action creator for loading an inspection in the inspectionPage
 * @example dispatch(requestInspection(inspectionId))
 */
export function requestInspection(inspectionId) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchInspection.toString()));
    dispatch(fetchInspection(requestId));

    try {
      const inspection = await get(`/api/inspections/${inspectionId}`);
      dispatch(putInspection(inspection));
      dispatch(requestSucceded(requestId, inspectionId));
    } catch (error) {
      if (error.code === 404) {
        dispatch(requestSucceded(requestId, inspectionId));
      } else {
        dispatch(requestFailed(requestId, error));
      }
    }
  };
}

/**
 * An action creator that represents an request to re-send an inspection report.
 * @example dispatch(fetchInspection(requestId)
 */
export const sendInspectionReport = createAction('SEND_INSPECTION_REPORT');


/**
 * A thunk action creator for requestinf to re-send an inspection report.
 * @example dispatch(requestSendInspectionReport(inspectionId, toAddress))
 */
export function requestSendInspectionReport(inspectionId, toAddress) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(sendInspectionReport.toString()));
    dispatch(sendInspectionReport(requestId));

    try {
      await post(`/api/inspections/${inspectionId}/send/${toAddress}`);
      dispatch(requestSucceded(requestId));
      dispatch(addMessage('success', 'emailSent'));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
      dispatch(addMessage('success', 'emailFail'));
    }
  };
}
